import * as Tone from 'tone';

let _initialized = false;

/**
 * Initialise l'AudioContext lazily depuis un event handler utilisateur.
 * Appelle Tone.start() pour débloquer le contexte audio Tone.js existant.
 * Doit être appelé depuis un onClick, onPointerDown, etc. — jamais dans un useEffect.
 *
 * NOTE : On n'utilise pas `new AudioContext()` car remplacer le contexte via
 * `Tone.setContext()` orpheline les samplers déjà créés (DrumSoundPlayer),
 * ce qui coupe le son dans les pages qui utilisent useAutoPlayback.
 */
export async function initAudio() {
  if (_initialized) return;
  await Tone.start();
  _initialized = true;
}

export function isAudioInitialized() {
  return _initialized;
}
